var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 100,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_1190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4891 0C112.525 0 145 32.2291 145 71.9891C145 111.749 112.525 144 72.4891 144C32.4529 144 0 111.749 0 71.9891C0 32.2291 32.4529 0 72.4891 0ZM72.4891 7.79141C54.6345 7.79141 38.4846 14.9751 26.7709 26.608C15.0573 38.2408 7.82366 54.2794 7.82366 72.0109C7.82366 89.7423 15.0573 105.803 26.7709 117.414C38.4627 129.047 54.6345 136.23 72.4891 136.23C90.3436 136.23 106.515 129.047 118.207 117.414C129.921 105.803 137.154 89.7423 137.154 72.0109C137.154 54.2794 129.921 38.2191 118.207 26.608C106.515 14.9968 90.3436 7.79141 72.4891 7.79141Z",
    fill: "#0081C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.918 77.8707H127.758V86.9209H106.035V55.9506H116.918V77.8707ZM81.4275 76.1561L63.5292 90.1329L47.1607 77.3498C44.8005 82.9709 39.1185 86.8992 32.5187 86.8992H18.5322V55.9289H32.5187C39.8615 55.9289 45.1502 60.5516 47.1389 65.4999L63.5074 52.7168L69.5827 57.4481L54.591 69.1677L57.4539 71.4032L72.4456 59.6835L78.5209 64.4148L63.5292 76.1344L66.4139 78.3915L81.4275 66.6936V55.9506H92.3107V77.8707H103.15V86.9426H81.4275V76.1778V76.1561ZM38.2007 71.4249C38.2007 67.2145 35.4034 64.8271 31.4478 64.8271H29.0221V78.0009H31.3823C35.0537 78.0009 38.2007 76.0042 38.2007 71.4032",
    fill: "#0081C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_1190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 144,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDell);
export default __webpack_public_path__ + "static/media/DELL.c42c62059cf57c12546fb7a36d66d0ef.svg";
export { ForwardRef as ReactComponent };